import { isBanobagiLayout } from "@/utils/layout";

// Campaign deadlines use Thailand time, independently of the device timezone.
export const BANOBAGI_CONNECTION_CUTOFF = Date.parse("2026-10-12T00:00:00+07:00");
export const BANOBAGI_SITE_CUTOFF = Date.parse("2026-10-14T00:00:00+07:00");

let enabled = false;

export function configureBanobagiAvailability(layout) {
  enabled = isBanobagiLayout(layout);
}

export function isBanobagiConnectionClosed(now = Date.now()) {
  return enabled && now >= BANOBAGI_CONNECTION_CUTOFF;
}

export function isBanobagiSiteClosed(now = Date.now()) {
  return enabled && now >= BANOBAGI_SITE_CUTOFF;
}

export function isBanobagiAvailabilityEnabled() {
  return enabled;
}
